import { AccountCircle, Email, Message, Send } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import PageContainer from "../component/PageContainer";
import Mail from "../assets/icon/home_message_icon.svg";
import "../css/ContactUs.css";
import { Helmet } from "react-helmet-async";
import { useMediaQuery } from "react-responsive";

const CONTACT_EMAIL = "info@nti.edu.ng";

function ContactUs() {
	const isPhone = useMediaQuery({ query: "(max-width: 812px)" });
	const [loadingContact, setLoadingContact] = useState(false);
	const [contact, setContact] = useState("");
	const [fullName, setFullName] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");

	const getContact = () => {
		setLoadingContact(true);
		fetch("https://cms.nti.edu.ng/api/contact-us")
			.then((res) => res.json())
			.then((res) => setContact(res?.general_info_body))
			.catch((err) => console.log(err))
			.finally(() => setLoadingContact(false));
	};

	useEffect(() => {
		getContact();
	}, []);

	const buildMailtoHref = () => {
		const subject = fullName
			? `Contact from ${fullName} — NTI Website`
			: "Contact from NTI Website";

		const body = [
			`Full name: ${fullName || ""}`,
			`Email address: ${email || ""}`,
			"",
			"Message:",
			message || "",
		].join("\n");

		return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
			subject,
		)}&body=${encodeURIComponent(body)}`;
	};

	return (
		<PageContainer>
			<Helmet>
				<title>Contact Us | National Teachers' Institute Kaduna</title>
			</Helmet>
			<section className="contact_section_wrapper">
				<div className="contact_info_section_address_wrapper">
					<div className="contct_address_wrapper">
						<h4 className="contact_section_h4">Contact Us</h4>
					</div>
					<div
						className="contact"
						dangerouslySetInnerHTML={{ __html: contact }}
					></div>
				</div>

				<div className="contact_form_wrapper contact_email_panel">
					<div className="contact_email_badge">
						<img src={Mail} alt="" />
						<span>Get in touch</span>
					</div>
					<h4 className="contact_email_heading">
						If you have any questions for us, we are happy to answer them
					</h4>
					<p className="contact_email_copy">
						Reach us at{" "}
						<a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> — fill in
						your details below and hit send.
					</p>

					<div className="contact_form contact_email_fields">
						<TextField
							className="contact_textfield"
							placeholder="Full name"
							value={fullName}
							onChange={(e) => setFullName(e.target.value)}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<AccountCircle className="contact_icon_color" />
									</InputAdornment>
								),
								disableUnderline: true,
							}}
							variant="standard"
						/>
						<TextField
							className="contact_textfield"
							placeholder="Email address"
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Email className="contact_icon_color" />
									</InputAdornment>
								),
								disableUnderline: true,
							}}
							variant="standard"
						/>
						<TextField
							className="contact_textfield contact_textfield_message"
							fullWidth
							placeholder="Message"
							value={message}
							onChange={(e) => setMessage(e.target.value)}
							multiline
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Message className="contact_icon_color" />
									</InputAdornment>
								),
								disableUnderline: true,
							}}
							sx={{ height: "160px" }}
							variant="standard"
						/>

						<a
							className="home_btn contact_btn contact_email_cta"
							href={buildMailtoHref()}
						>
							Send
							<Send fontSize="small" />
						</a>
					</div>
				</div>
			</section>
			<div className="map-picture">
				<iframe
					title="NTI Kaduna location map"
					src="https://maps.google.com/maps?q=KM%205%20Kaduna%20%E2%80%93%20Zaria%20Express%20Way,%20Rigachikun,%20Kaduna,%20Nigeria.&t=&z=13&ie=UTF8&iwloc=&output=embed"
					style={{
						marginLeft: isPhone ? "0rem" : "7rem",
						border: 0,
						marginBottom: "3rem",
						width: isPhone ? "100%" : "80%",
						height: 350,
					}}
					allowFullScreen=""
				></iframe>
			</div>
		</PageContainer>
	);
}

export default ContactUs;
